/**
 * The scales the artefact's integers were made with.
 *
 * Duplicated from the pipeline's own `scales.ts` rather than imported: the
 * client must not depend on the data package, and a decoder that guessed these
 * would be wrong silently. `bun run validate` compares the two sides value by
 * value on every build, so a divergence fails there rather than in a browser.
 */

/** Percentages to two decimals — weights, fees, yields. */
export const PERCENT = 100;

/** Distribution and tax amounts, published to five decimals. */
export const AMOUNT = 100_000;

/** Allocation weights, which exceed 100% on a levered fund. */
export const ALLOCATION = 10_000;

/** Assets are a whole number of ten-thousands. */
export const UNITS = { assets: 10_000 } as const;
